import { useEffect } from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import brightstarLogo from '../../assets/brightstar-logo.png';

const jurisdictions = [
  { label: 'Michigan', path: '/mi', bg: 'var(--mi-primary)', color: '#ffffff' },
  { label: 'New Jersey', path: '/nj', bg: 'var(--nj-secondary)', color: '#ffffff' },
  { label: 'Texas', path: '/tx', bg: 'var(--tx-secondary)', color: '#ffffff' },
  { label: 'West Virginia', path: '/wv', bg: 'var(--wv-secondary)', color: '#ffffff' },
];

export default function DevLanding() {
  useEffect(() => {
    document.title = 'RSS Orders — Dev Portal';
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = brightstarLogo;
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backgroundColor: '#1a1a2e',
      }}
    >
      <Typography variant='h5' sx={{ color: '#ffffff', mb: 2, letterSpacing: 2 }}>
        RSS ORDERS — DEV PORTAL
      </Typography>
      <Stack direction='row' spacing={2} flexWrap='wrap' justifyContent='center'>
        {jurisdictions.map(({ label, path, bg, color }) => (
          <Button
            key={path}
            component={Link}
            to={path}
            variant='contained'
            sx={{
              backgroundColor: bg,
              color,
              px: 4,
              py: 2,
              fontSize: '1rem',
              '&:hover': { opacity: 0.85, backgroundColor: bg },
            }}
          >
            {label}
          </Button>
        ))}
      </Stack>
    </Box>
  );
}
